import { render, staticRenderFns } from "./DynamsoftBarcodeScanner.vue?vue&type=template&id=364cb6c2&scoped=true&"
import script from "./DynamsoftBarcodeScanner.vue?vue&type=script&lang=ts&"
export * from "./DynamsoftBarcodeScanner.vue?vue&type=script&lang=ts&"
import style0 from "./DynamsoftBarcodeScanner.vue?vue&type=style&index=0&id=364cb6c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "364cb6c2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VContainer})
